import { useCallback, useEffect, useRef, useState } from "react";
import { taslakKaydet, taslakOku, taslakSil } from "./formDrafts";
import { registerDirtyForm } from "./dirtyForms";

// FAZ G — Form taslağı kancası. Yazma YALNIZCA çıkış/kapanış anlarında yapılır
// (tuş başına yazma YOK, DOM/performans için kritik).
export const useFormDraft = ({ userId, formKey, topla, kirli }) => {
  const [teklif, setTeklif] = useState(null);
  const fnRef = useRef({ topla, kirli });
  fnRef.current = { topla, kirli };

  useEffect(() => {
    setTeklif(formKey ? taslakOku(userId, formKey) : null);
  }, [userId, formKey]);

  const yaz = useCallback(() => {
    if (!formKey) return false;
    const veri = fnRef.current.topla?.();
    if (!veri) return false;
    return taslakKaydet(userId, formKey, veri);
  }, [userId, formKey]);

  const sil = useCallback(() => {
    if (formKey) taslakSil(userId, formKey);
    setTeklif(null);
  }, [userId, formKey]);

  // "HEPSİNİ TOPLA" öncesi kaydedilmemiş bilgi sayımı/taslak yazımı için kayıt.
  useEffect(
    () => registerDirtyForm({ kirli: () => fnRef.current.kirli?.(), yaz }),
    [yaz],
  );

  // Sekme/tarayıcı kapatma veya yenileme: form kirliyse taslağı kaydet.
  useEffect(() => {
    const onUnload = () => { if (fnRef.current.kirli?.()) yaz(); };
    window.addEventListener("beforeunload", onUnload);
    return () => window.removeEventListener("beforeunload", onUnload);
  }, [yaz]);

  return { teklif, setTeklif, yaz, sil };
};

export default useFormDraft;
